import React from 'react';
import { useNavigate } from 'react-router-dom';

import { RegistrationCompleteView } from './RegistrationComplete.view';

/**
 * Registration complete, the container. Navigation only.
 *
 * Everything visual lives in `RegistrationComplete.view.jsx`, which is pure, so
 * the state explorer can mount the real screen without a router.
 *
 * `RegistrationComplete.css` is gone: nothing else imported it and the page no
 * longer emits one of its class names.
 */

export default function RegistrationComplete() {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return <RegistrationCompleteView onGoToDashboard={handleGoToDashboard} />;
}
